var map = {
	"./Accordion.svg": 923,
	"./Acoustic_Guitar.svg": 6915,
	"./Bagpipe.svg": 1839,
	"./Banjo.svg": 691,
	"./Bassoon.svg": 3294,
	"./Bell_Tree.svg": 7383,
	"./Cajon.svg": 1580,
	"./Children.svg": 2646,
	"./Choir.svg": 28,
	"./Claps.svg": 8504,
	"./Clarinet.svg": 513,
	"./Clave.svg": 1256,
	"./Clavichord.svg": 1234,
	"./Cowbell.svg": 4651,
	"./Crotales.svg": 4162,
	"./Cymbals.svg": 9516,
	"./Djembe.svg": 4440,
	"./Drum_Kit.svg": 4750,
	"./Electric_Drum.svg": 3085,
	"./Electric_Guitar.svg": 2311,
	"./Erhu.svg": 7375,
	"./Female.svg": 1835,
	"./Flutes.svg": 4330,
	"./French_Horns.svg": 5720,
	"./Guiro.svg": 3953,
	"./Harmonica.svg": 327,
	"./Harmonium.svg": 89,
	"./Harp.svg": 7288,
	"./Harpsichord.svg": 3510,
	"./Hulusi.svg": 7663,
	"./Koto.svg": 2462,
	"./Male.svg": 9896,
	"./Maracas.svg": 6585,
	"./Melodica.svg": 607,
	"./Oboe.svg": 3076,
	"./Ocarina.svg": 5422,
	"./Pan_Flute.svg": 439,
	"./Piano.svg": 6258,
	"./Pipa.svg": 999,
	"./Pipe_Organ.svg": 2469,
	"./Ratchet.svg": 862,
	"./Saxophone.svg": 5864,
	"./Sitar.svg": 2480,
	"./String_Ensemble.svg": 7630,
	"./Suona.svg": 9881,
	"./Synthesizer.svg": 6831,
	"./Tambourine.svg": 3059,
	"./Timbales.svg": 8248,
	"./Timpani.svg": 1121,
	"./Triangle.svg": 1607,
	"./Trombones.svg": 4130,
	"./Trumpet.svg": 2202,
	"./Tuba.svg": 7929,
	"./Tubular_Bells.svg": 4313,
	"./Ukulele.svg": 5196,
	"./Violin.svg": 3592,
	"./Whistle.svg": 3419,
	"./Woodblock.svg": 283,
	"./Xylophone.svg": 2871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8925;